{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ChevronsUpIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ChevronsUpIcon = React.forwardRef<SVGSVGElement, ChevronsUpIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 93 99"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M44.7951 49.3095C39.2733 55.7514 33.5843 61.8015 28.5797 68.3728C21.8398 77.2222 15.6031 86.4575 9.20251 95.5629C7.44024 98.0701 4.95612 98.9922 2.8053 97.696C0.594754 96.3649 0.0663444 93.4837 1.84371 91.109C10.5402 79.4919 19.19 67.8307 28.0926 56.3698C31.9709 51.3776 36.4281 46.8384 40.5978 42.0688C43.7482 38.4589 46.8127 38.48 49.8522 42.1548C60.2223 54.6922 70.6022 67.2217 80.9915 79.7433C84.4183 83.852 88.0938 87.7505 91.5264 91.8565C92.3607 92.8164 92.8463 94.03 92.9046 95.3004C92.839 97.1703 90.6383 97.8942 88.8708 96.6071C87.1051 95.3198 85.4713 93.8609 83.993 92.2517C71.7326 78.8965 59.5027 65.5139 47.3036 52.1036C46.5751 51.3061 45.8596 50.4968 44.7951 49.3095Z" fill={color}/>
<path d="M44.7953 9.92959C39.2735 16.3715 33.5845 22.4216 28.5799 28.9929C21.84 37.8423 15.6034 47.0776 9.20275 56.183C7.44049 58.6902 4.95636 59.6124 2.80554 58.3161C0.594998 56.985 0.0665886 54.1038 1.84395 51.7291C10.5404 40.112 19.1903 28.4508 28.0928 16.9899C31.9711 11.9978 36.4283 7.45849 40.598 2.68888C43.7484 -0.920974 46.8129 -0.899904 49.8524 2.77493C60.2226 15.3123 70.6024 27.8418 80.9918 40.3634C84.4185 44.4721 88.094 48.3706 91.5267 52.4767C92.361 53.4365 92.8465 54.6501 92.9049 55.9205C92.8393 57.7904 90.6386 58.5143 88.871 57.2273C87.1054 55.9399 85.4715 54.481 83.9932 52.8718C71.7328 39.5167 59.503 26.134 47.3038 12.7237C46.5753 11.9262 45.8599 11.1169 44.7953 9.92959Z" fill={color}/>

      </svg>
    )
  }
)

ChevronsUpIcon.displayName = 'ChevronsUpIcon'
